import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import { xsRegular } from 'styles/typography';

export const Wrapper = styled.div``;

export const Title = styled.span`
	display: block;
	width: 100%;
	font-weight: 500;
	font-size: 23px;
	line-height: 31px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	padding-bottom: 12px;
`;

export const Description = styled.div`
	${xsRegular};
	color: ${colors.grey500};
`;

export const Divider = styled.div`
	height: 1px;
	width: 100%;
	background-color: ${colors.grey2};
	margin-top: 16px;
	margin-bottom: 17px;
`;

export const FormWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
`;

export const FormItemWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 15px;
	.ap-chip {
		border-radius: 0;
	}
	.remove_icon {
		height: 31px;
		width: 31px;
		border-radius: 0;
		border: 1px solid ${colors.amber400};
	}
	.remove_icon > i {
		color: ${colors.amber400};
	}
`;

export const ActionWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 15px;
`;
